import * as React from "react";
import { Progress } from "reactstrap";

const Loading = () => <Progress animated value={100} />;

export default Loading;
